import { render, staticRenderFns } from "./IosSelect.vue?vue&type=template&id=5d29c6fe&scoped=true&"
import script from "./IosSelect.vue?vue&type=script&lang=js&"
export * from "./IosSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29c6fe",
  null
  
)

export default component.exports